import { type HttpClient } from '@/application/interfaces/http-client';

import { postNewsletterSubscription } from './post-newsletter-subscription';

const NewsletterService = (httpClient: HttpClient.Instance) => ({
  postNewsletterSubscription: postNewsletterSubscription(httpClient),
});

export default NewsletterService;
